import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import QuestionForm from './index'
import RenderBody from '../../../modals/common/RenderBody'
import {currentTrashedPreviewItemSelector} from '../../../../modules/questions'
import {hideModal, TRASHED_QUESTION_MODAL} from '../../../../modules/modals'


class TrashedQuestionFormModal extends Component {
    render() {

        let {currentTrashed : {id : trashedQuestionId, form : {errors : {recover = [], removeErr = []} = {}} = {}}, recoverCB, removeCB} = this.props
        const {formatMessage} = this.context

        if (!trashedQuestionId) return null
        let errors = [...recover, ...removeErr]

        return (
            <RenderBody
                title = {`${formatMessage(`Trashed question ID:`)} ${trashedQuestionId}`}
                modalClassName = "trashed-question-modal"
                bodyClassName="trashed-question-modal-body"
                handleClose={this.hideModal}
                render = {() => {
                    return (
                        <React.Fragment>
                            <QuestionForm viewMode = {true} questionId = {trashedQuestionId} withTrashed = {true} isTrashed = {true} />
                            {
                                !!errors.length &&
                                <div className="row">
                                    <div className="col-xs-12 text-danger">
                                        {
                                            errors.map(error => <p key = {error}>{formatMessage(error)}</p>)
                                        }
                                    </div>
                                </div>
                            }
                            <div className="create-dialog-form__group flex flex-between">
                                <button
                                    onClick = {this.hideModal}
                                    className="btn btn-default"
                                    type = "button"
                                >{formatMessage('Cancel')}</button>
                                <button
                                    onClick={recoverCB}
                                    className="btn btn-primary"
                                    type="button"
                                >{formatMessage('Recover')}</button>
                                <button
                                    onClick={removeCB}
                                    className="btn btn-warning"
                                    type="button"
                                >{formatMessage('Remove')}</button>
                            </div>
                        </React.Fragment>
                    )
                } }
            />
        )
    }

    hideModal = () => this.props.hideModal({modalType : TRASHED_QUESTION_MODAL})

    static propTypes = {
        recoverCB : PropTypes.func.isRequired,
        removeCB : PropTypes.func.isRequired,
    }
    static contextTypes = {formatMessage: PropTypes.func}
}

export default connect(
    state => {
        let currentTrashed  = currentTrashedPreviewItemSelector(state) || {};    
        return {
            currentTrashed,
        }
    },
    {hideModal},
)(TrashedQuestionFormModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/TrashedQuestionFormModal.js